import { render } from "./modify-playgrounds.template.html?vue&type=template&id=d7db35be&scoped=true"
import script from "./ModifyPlaygrounds.vue?vue&type=script&lang=ts"
export * from "./ModifyPlaygrounds.vue?vue&type=script&lang=ts"

import "./ModifyPlaygrounds.vue?vue&type=style&index=0&id=d7db35be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d7db35be"

export default script